import * as React from 'react';
import { useSelector } from 'react-redux';

import { Responsive } from '@cian/ui-kit';

import { DesktopPageContainer, MobilePageContainer } from './views';
import { useDataLoadingOtherBlocks } from './utils';
import { useSendBlocksExists } from '../../utils/teaser/useSendBlocksExists';
import { selectDealType } from '../../selectors/page';

export function ReportPageContainer() {
  const dealType = useSelector(selectDealType);
  useDataLoadingOtherBlocks();
  const sendBlocksExists = useSendBlocksExists();

  React.useEffect(() => {
    sendBlocksExists();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dealType]);

  return (
    <>
      <Responsive desktop>
        <DesktopPageContainer />
      </Responsive>

      <Responsive phone tablet>
        <MobilePageContainer />
      </Responsive>
    </>
  );
}
